/**
 * Keeps any rendered SKU/REF (marked with [data-product-sku-number]) truncated to its
 * first two "_"-separated parts, even after the theme's built-in variant-change handlers
 * overwrite it with the full SKU (e.g. product-meta custom element).
 */
(function () {
  if (window.__mtngSkuShortenerInit) return;
  window.__mtngSkuShortenerInit = true;

  var shortenSku = function (value) {
    if (typeof value !== 'string') return value;
    var parts = value.split('_');
    return parts.length > 2 ? parts.slice(0, 2).join('_') : value;
  };

  var applyAll = function () {
    var elements = document.querySelectorAll('[data-product-sku-number]');
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var current = el.textContent;
      var shortened = shortenSku(current);
      if (shortened !== current) {
        el.textContent = shortened;
      }
    }
  };

  applyAll();

  var scheduled = false;
  var scheduleApply = function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyAll();
    });
  };

  var observer = new MutationObserver(scheduleApply);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  document.addEventListener('variant:changed', scheduleApply, true);
})();
